import jsonpack from 'jsonpack';

const getDecodedQueryParams = <T>(data: string): T => {
  return jsonpack.unpack(decodeURIComponent(window.atob(data))) as T;
};

export default getDecodedQueryParams;

export const decodedParamsWithExceptionHandled = <T>(data: string): T | null => {
  let decodedData: T | null = null;
  try {
    decodedData = jsonpack.unpack(decodeURIComponent(window.atob(data))) as T;
  } catch (e) {
    console.log(e);
  }
  return decodedData;
};
